import { render, staticRenderFns } from "./ServiceInquiryList.vue?vue&type=template&id=2a7da7c9&scoped=true"
import script from "./ServiceInquiryList.vue?vue&type=script&lang=js"
export * from "./ServiceInquiryList.vue?vue&type=script&lang=js"
import style0 from "./ServiceInquiryList.vue?vue&type=style&index=0&id=2a7da7c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7da7c9",
  null
  
)

export default component.exports